import { createFetcherReducer } from '../utils';
import { LOADING_SIBLINGS, RECEIVED_SIBLINGS, RECEIVED_SIBLINGS_FAILED } from '../../actions/types';

export default createFetcherReducer(
  LOADING_SIBLINGS, RECEIVED_SIBLINGS, RECEIVED_SIBLINGS_FAILED,
);
